export const vueEditorToolbar = [
    [{ header: [] }],
    [], // toggled buttons
    [],
    [],
    [], // outdent/indent
    [], // dropdown with defaults from theme
];

export const genders = [
    {
        "id": 1,
        "specificatif": "Masculin",
        "description": "Homme"
    },
    {
        "id": 2,
        "specificatif": "Féminin",
        "description": "Femme"
    }
];